/**
 * Team members state for My Team.
 * Placeholder until API is connected.
 */
import { createSlice } from "@reduxjs/toolkit";

export interface MemberItem {
  id: string | number;
  name?: string;
  email?: string;
  access?: string;
  status?: string;
  last_activity?: string;
  lastActive?: string;
  [key: string]: unknown;
}

export interface MembersCounts {
  total_members: number;
  pending_users: number;
  active_users: number;
  recruiters: number;
  admins: number;
}

export interface MembersState {
  list: MemberItem[];
  listTotal: number;
  loading: boolean;
  error: string | null;
  counts: MembersCounts | null;
  countsLoading: boolean;
}

const initialState: MembersState = {
  list: [],
  listTotal: 0,
  loading: false,
  error: null,
  counts: null,
  countsLoading: false,
};

const membersSlice = createSlice({
  name: "members",
  initialState,
  reducers: {
    setMembersList: (state, action) => {
      state.list = action.payload;
    },
    setMembersListTotal: (state, action) => {
      state.listTotal = action.payload;
    },
    setMembersLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMembersError: (state, action) => {
      state.error = action.payload;
    },
    setMembersCounts: (state, action) => {
      state.counts = action.payload;
    },
    setMembersCountsLoading: (state, action) => {
      state.countsLoading = action.payload;
    },
    updateMemberInList: (state, action) => {
      const { id, updates } = action.payload as { id: string | number; updates: Partial<MemberItem> };
      const index = state.list.findIndex((m) => m.id === id);
      if (index !== -1) {
        state.list[index] = { ...state.list[index], ...updates };
      }
    },
    removeMemberFromList: (state, action) => {
      state.list = state.list.filter((m) => m.id !== action.payload);
    },
  },
});

export const {
  setMembersList,
  setMembersListTotal,
  setMembersLoading,
  setMembersError,
  setMembersCounts,
  setMembersCountsLoading,
  updateMemberInList,
  removeMemberFromList,
} = membersSlice.actions;
export default membersSlice.reducer;
